import { IRobotSentence, IRobotWordClick } from './robots.interface';

/**
 * @todo Renomear esta interface para IRobot e sua classe para Robot.
 * Verificar se não vai dar conflito de nomes. Aproveitar e organizar as interfaces melhor.
 */
export interface IClassificationParameters {
  robotId: string;
  id: string;
  /**
   * @deprecated Agora não usamos mais esse ID. Usar o ID do robô.
   */
  classificationId: string;
  sentences: IRobotSentence[];
  wordClicks: IRobotWordClick[];
  type: ClassificationParameterTypeEnum;
  readonly createDate: Date;
  readonly createUser: string;
  readonly updateDate?: Date;
  readonly updateUser?: string;
  readonly deleteDate?: Date;
  readonly deleteUser?: string;
  version: string;
  discriminator?: string;
  fileIds: string[];
  name?: string;
  state?: string;
  pages?: IClassificationParametersPage[];
  toJson: () => { [key: string]: any };
}

export interface IClassificationParametersPage {
  state?: string;
  wordClicks: IRobotWordClick[];
  isComplementary: boolean;
  sentences: IRobotSentence[];
}

export enum ClassificationParameterTypeEnum {
  ocr = 1,
  xPath = 2,
}
